import { render, staticRenderFns } from "./DashboardOrders.vue?vue&type=template&id=46ff0f9e&"
import script from "./DashboardOrders.vue?vue&type=script&lang=js&"
export * from "./DashboardOrders.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports